import { call, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { RulesService } from '../services/rules.service'
import { IRules, IRulesList } from '../../pcr/models/rules.V1'
import { priorityCompare } from '../../../utilities/number.util'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* getRules() {
  try {
    const serviceId: string = yield select(getServiceIdSelector)
    const rulesService = new RulesService(serviceId)

    const getRulesResponse: IRulesList = yield call([rulesService, rulesService.getRules])
    const { entity } = getRulesResponse

    entity.sort((e1: IRules, e2: IRules) => priorityCompare(e1.priority, e2.priority))

    RulesService.loadRulesForService(serviceId, entity)
  } catch (e) {
    // TODO: Put this back once we actually have rules.
    // Commenting out for now so we don't get spammed by Log Rocket
    // yield put(throwPcrException(`getRules() error: ${e}`))
  }
}

export function* getRulesSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getRules)
}
